import { ReactElement } from 'react';
import classnames from 'classnames';

import { Spinner } from '@/components/ui/spinner';

import './loader.css';

type LoaderPropTypes = {
  show?: boolean;
  className?: string;
  position?: boolean;
  inline?: boolean;
};

const Loader = (props: LoaderPropTypes): ReactElement => {
  const { show, className, position, inline = false } = props;
  const classes = classnames('Loader', className, {
    'Loader--visible': show,
  });

  const loaderClasses = classnames('Loader__content', {
    'Loader__content--height': position,
  });

  const highResolutionSpinner = (
    <Spinner size="lg" className="border-t-primary" />
  );

  if (inline && show) {
    return <div className={loaderClasses}>{highResolutionSpinner}</div>;
  }

  return (
    <div className={classes}>
      <div className={loaderClasses}>{highResolutionSpinner}</div>
    </div>
  );
};

export default Loader;
